/**
 * @flow
 * @relayHash a50815587a6712c9d8fcf1f0a11b0aa9
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ItemSubComponentsTreeQueryVariables = {|
  id: string
|};
export type ItemSubComponentsTreeQueryResponse = {|
  +item: {|
    +id: string,
    +name: string,
    +itemNumber: string,
    +description: ?string,
    +partNumber: ?string,
    +upc: ?string,
    +cost: ?number,
    +totalCalculatedCost: ?number,
    +quantityUOM: {|
      +id: string,
      +symbol: string,
    |},
    +category: ?{|
      +id: string,
      +name: string,
    |},
    +childItems: {|
      +edges: ?$ReadOnlyArray<?{|
        +usageQty: ?number,
        +bomType: ?string,
        +referenceDesignator: ?string,
        +findNumber: ?string,
        +notes: ?string,
        +isPhantom: ?boolean,
        +scrapFactor: ?number,
        +leadTimeOffsetDays: ?number,
        +isBackflush: ?boolean,
        +workflowStateId: ?string,
        +fixedQuantity: ?number,
        +isOptional: ?boolean,
        +selectionGroup: ?string,
        +isDefaultSelection: ?boolean,
        +optionLabel: ?string,
        +minQuantity: ?number,
        +maxQuantity: ?number,
        +priceAdjustment: ?number,
        +isCustomerVisible: ?boolean,
        +salesDisplayName: ?string,
        +componentPrice: ?number,
        +discountPercent: ?number,
        +sortOrder: ?number,
        +isShippedSeparately: ?boolean,
        +isReplaceable: ?boolean,
        +serviceIntervalDays: ?number,
        +meanTimeBetweenFailure: ?number,
        +repairMethod: ?string,
        +serviceNotes: ?string,
        +isCriticalSpare: ?boolean,
        +node: {|
          +id: string,
          +itemNumber: string,
          +name: string,
          +description: ?string,
          +partNumber: ?string,
          +upc: ?string,
          +cost: ?number,
          +totalCalculatedCost: ?number,
          +quantityUOM: {|
            +id: string,
            +symbol: string,
          |},
          +category: ?{|
            +id: string,
            +name: string,
          |},
        |},
      |}>
    |},
  |}
|};
export type ItemSubComponentsTreeQuery = {|
  variables: ItemSubComponentsTreeQueryVariables,
  response: ItemSubComponentsTreeQueryResponse,
|};
*/


/*
query ItemSubComponentsTreeQuery(
  $id: ID!
) {
  item(id: $id) {
    id
    name
    itemNumber
    description
    partNumber
    upc
    cost
    totalCalculatedCost
    quantityUOM {
      id
      symbol
    }
    category {
      id
      name
    }
    childItems {
      edges {
        usageQty
        bomType
        referenceDesignator
        findNumber
        notes
        isPhantom
        scrapFactor
        leadTimeOffsetDays
        isBackflush
        workflowStateId
        fixedQuantity
        isOptional
        selectionGroup
        isDefaultSelection
        optionLabel
        minQuantity
        maxQuantity
        priceAdjustment
        isCustomerVisible
        salesDisplayName
        componentPrice
        discountPercent
        sortOrder
        isShippedSeparately
        isReplaceable
        serviceIntervalDays
        meanTimeBetweenFailure
        repairMethod
        serviceNotes
        isCriticalSpare
        node {
          id
          itemNumber
          name
          description
          partNumber
          upc
          cost
          totalCalculatedCost
          quantityUOM {
            id
            symbol
          }
          category {
            id
            name
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "itemNumber",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "partNumber",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "upc",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cost",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalCalculatedCost",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "quantityUOM",
  "storageKey": null,
  "args": null,
  "concreteType": "UOM",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "symbol",
      "args": null,
      "storageKey": null
    }
  ]
},
v11 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "category",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemCategory",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/)
  ]
},
v12 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "ItemChildEdge",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "usageQty",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "bomType",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "referenceDesignator",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "findNumber",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "notes",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "isPhantom",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "scrapFactor",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "leadTimeOffsetDays",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "isBackflush",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "workflowStateId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "fixedQuantity",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "isOptional",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "selectionGroup",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "isDefaultSelection",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "optionLabel",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "minQuantity",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "maxQuantity",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "priceAdjustment",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "isCustomerVisible",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "salesDisplayName",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "componentPrice",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "discountPercent",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "sortOrder",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "isShippedSeparately",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "isReplaceable",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceIntervalDays",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "meanTimeBetweenFailure",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "repairMethod",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceNotes",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "isCriticalSpare",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "Item",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          (v3/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "__typename",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "cursor",
        "args": null,
        "storageKey": null
      }
    ]
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "endCursor",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "hasNextPage",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ItemSubComponentsTreeQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "item",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "Item",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "kind": "LinkedField",
            "alias": "childItems",
            "name": "__Item_childItems_connection",
            "storageKey": null,
            "args": null,
            "concreteType": "ItemChildConnection",
            "plural": false,
            "selections": (v12/*: any*/)
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ItemSubComponentsTreeQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "item",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "Item",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "childItems",
            "storageKey": null,
            "args": null,
            "concreteType": "ItemChildConnection",
            "plural": false,
            "selections": (v12/*: any*/)
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "childItems",
            "args": null,
            "handle": "connection",
            "key": "Item_childItems",
            "filters": []
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "ItemSubComponentsTreeQuery",
    "id": null,
    "text": "query ItemSubComponentsTreeQuery(\n  $id: ID!\n) {\n  item(id: $id) {\n    id\n    name\n    itemNumber\n    description\n    partNumber\n    upc\n    cost\n    totalCalculatedCost\n    quantityUOM {\n      id\n      symbol\n    }\n    category {\n      id\n      name\n    }\n    childItems {\n      edges {\n        usageQty\n        bomType\n        referenceDesignator\n        findNumber\n        notes\n        isPhantom\n        scrapFactor\n        leadTimeOffsetDays\n        isBackflush\n        workflowStateId\n        fixedQuantity\n        isOptional\n        selectionGroup\n        isDefaultSelection\n        optionLabel\n        minQuantity\n        maxQuantity\n        priceAdjustment\n        isCustomerVisible\n        salesDisplayName\n        componentPrice\n        discountPercent\n        sortOrder\n        isShippedSeparately\n        isReplaceable\n        serviceIntervalDays\n        meanTimeBetweenFailure\n        repairMethod\n        serviceNotes\n        isCriticalSpare\n        node {\n          id\n          itemNumber\n          name\n          description\n          partNumber\n          upc\n          cost\n          totalCalculatedCost\n          quantityUOM {\n            id\n            symbol\n          }\n          category {\n            id\n            name\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n}\n",
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "item",
            "childItems"
          ]
        }
      ]
    }
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '72736e56aec585108f01de64c96daac2';
module.exports = node;
